import React from 'react';

/**
 * FishingSpots Component
 * Renders clickable fishing spots on the map with larger click areas
 */
const FishingSpots = ({ spots, onSpotClick, playerX, playerY }) => {
  // Check if player is within range of a spot (64 pixels - more forgiving)
  const isInRange = (spot) => {
    const dx = Math.abs(playerX - spot.player_x);
    const dy = Math.abs(playerY - spot.player_y);
    return dx <= 64 && dy <= 64;
  };

  return (
    <>
      {spots.map((spot, index) => {
        const inRange = isInRange(spot);
        
        return (
          <div
            key={index}
            onClick={() => inRange && onSpotClick(spot, index)}
            style={{
              position: 'absolute',
              left: `${spot.click_x - 24}px`, // Center the 64x64 area
              top: `${spot.click_y - 24}px`,
              width: '64px',  // Larger click area
              height: '64px',
              cursor: inRange ? 'pointer' : 'not-allowed',
              opacity: inRange ? 1 : 0.5,
            //   border: '3px solid rgba(64, 164, 223, 0.9)',
              borderRadius: '50%',
              background: inRange 
                ? 'radial-gradient(circle, rgba(64, 164, 223, 0.4), rgba(64, 164, 223, 0.1))' 
                : '',
              pointerEvents: inRange ? 'auto' : 'none',
              transition: 'all 0.3s ease',
              zIndex: 10,
              animation: inRange ? 'fishingSpotPulse 2s infinite' : 'none',
              boxShadow: inRange 
                ? '0 0 20px rgba(64, 164, 223, 0.6), inset 0 0 20px rgba(64, 164, 223, 0.3)' 
                : ''
            }}
            title={inRange ? 'Click to fish' : 'Move closer to fish'}
          >
            {/* Fishing icon */}
            {/* <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '24px',
              pointerEvents: 'none',
              textShadow: '0 0 8px rgba(0, 0, 0, 0.8)',
              filter: inRange ? 'none' : 'grayscale(100%)'
            }}>
              🎣
            </div> */}
            
            {/* Range indicator ring */}
            {/* <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '80%',
              height: '80%',
              border: '2px dashed rgba(255, 255, 255, 0.5)',
              borderRadius: '50%',
              pointerEvents: 'none',
              animation: inRange ? 'fishingRingRotate 4s linear infinite' : 'none'
            }} /> */}
          </div>
        );
      })}
      
      <style>{`
        @keyframes fishingSpotPulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.15);
            opacity: 0.8;
          }
        }
        
        @keyframes fishingRingRotate {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default FishingSpots;
